import { combineReducers } from 'redux';
import microsoft from '../../microsoft/reducers';

export default combineReducers({
  microsoft
});
